module.exports = __webpack_public_path__ + "f813df4f3f98f92f27d945cabf195ca9.svg";